<template>
    <div id="EstimationsWrapper">
        <div id="EstimationTopContainer">
            <div id="EstimationSelectionContainer">
                <div><img :class="{ 'Button': true, 'TriangleBtnVisible': SelectedMikomiIndex > 0 }" style="visibility: hidden;" width="32" height="32" src="../assets/Icon_Triangle_Left.svg" /></div>
                <GenericDropdown style="width: 300px;" :options="EstimationList" :OnChange="OnSelectEstimation"  />
                <div><img :class="{'Button': true, 'TriangleBtnVisible': SelectedMikomiIndex < EstimationList.length - 1 }" style="visibility: hidden; transform: rotateY(180deg);" width="32" height="32" src="../assets/Icon_Triangle_Left.svg" /></div>
                <div>
                    <div id="EstimationToggleBtn" class="Button ButtonNormal NoSelect" style="width: 60px;" @click="ToggleNewEstimation">
                        新しい
                    </div>
                </div>
                <div>
                    <div class="Button ButtonNormal NoSelect" @click="OpenResultDetails">
                        実績ディテール
                    </div>
                </div>
            </div>
            <div id="EstimationDataFilterContainer" v-if="IsNewEstimationVisible === false">
                <div class="EstimationFilter">
                    <span>時間枠</span>
                    <GenericMultiDropdown style="direction: rtl;" ref="TimelineFilter" :-input-placeholder="''" :options="TimelineFilterOptions" :-allow-multiple=true :-on-change="OnTimelineFilterChange" />
                </div>
                <div class="EstimationFilter">
                    <span>チーム</span>
                    <GenericMultiDropdown style="direction: rtl;" ref="TeamFilter" :-input-placeholder="''" :options="TeamFilterOptions" :-allow-multiple=true :-on-change="OnTeamFilterChange" />
                </div>
            </div>
        </div>
        <div id="EstimationBottomContainer" v-if="IsNewEstimationVisible === false">
            <div id="EstimationsTeamsContainer">
                <!-- SEPARATE HEADERS FROM SCROLLABLE CONTAINERS -->
                <div class="EstimationsDataHeader" style="min-height: 48px; max-height: 48px;">&nbsp;</div>
                <div id="LeftSideScrollContainer">
                    <div class="EstimationsTeamEntry">
                        <div class="EstimationTeamName">トイホビー</div>
                        <div class="EstimationTeamData">
                            <div v-if="IsTeamFiltered('フィギュア')" style="background-color: #B7DEE8;">売上（フィギュア）</div>
                            <div v-if="IsTeamFiltered('フィギュア')" style="background-color: #B7DEE8;">総益仮</div>
                            <div v-if="IsTeamFiltered('フィギュア')" style="background-color: #B7DEE8;">総益仮(率)</div>
                            <div v-if="IsTeamFiltered('プラモ')" style="background-color: #FDE9D9;">売上（プラモ）</div>
                            <div v-if="IsTeamFiltered('プラモ')" style="background-color: #FDE9D9;">総益仮</div>
                            <div v-if="IsTeamFiltered('プラモ')" style="background-color: #FDE9D9;">総益仮(率)</div>
                            <div v-if="IsTeamFiltered('デジタル')" style="background-color: #D8E4BC;">売上（デジタル414）</div>
                            <div v-if="IsTeamFiltered('デジタル')" style="background-color: #D8E4BC;">総益仮</div>
                            <div v-if="IsTeamFiltered('デジタル')" style="background-color: #D8E4BC;">総益仮(率)</div>
                            <div v-if="IsTeamFiltered('XPNA')" style="background-color: #dd9999;">売上（XPNA）</div>
                            <div v-if="IsTeamFiltered('XPNA')" style="background-color: #dd9999;">総益仮</div>
                            <div v-if="IsTeamFiltered('XPNA')" style="background-color: #dd9999;">総益仮(率)</div>
                            <div style="background-color: #FFFF00;">売上（TTL）</div>
                            <div style="background-color: #FFFF00;">総益仮</div>
                            <div style="background-color: #FFFF00;">総益仮(率)</div>
                            <div>総益</div>
                            <div>営業利益</div>
                            <div>営業利益率</div>
                            <div>純利益</div>
                            <div>在庫</div>
                        </div>
                    </div>
                    <div class="EstimationsTeamEntry">
                        <div class="EstimationTeamName">ゲーム開発</div>
                        <div class="EstimationTeamData">
                            <div>売上</div>
                            <div>総益仮</div>
                            <div>総益仮(率)</div>
                            <div>総益</div>
                            <div>営業利益</div>
                            <div>営業利益率</div>
                            <div>純利益</div>
                            <div>在庫</div>
                        </div>
                    </div>
                    <div class="EstimationsTeamEntry">
                        <div class="EstimationTeamName">3部TTL</div>
                        <div class="EstimationTeamData">
                            <div>売上</div>
                            <div>総益仮</div>
                            <div>総益仮(率)</div>
                            <div>総益</div>
                            <div>営業利益</div>
                            <div>営業利益率</div>
                            <div>純利益</div>
                            <div>在庫</div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="EstimationsDataContainer">
                <div id="TimelineScrollContainer" class="EstimationsDataHeader EstimationsDataHeaderPadding">
                    <template v-for="TimeEntry in TimelineEntries" :key="TimeEntry.label">
                        <div class="EstimationsDataTimelineEntry">
                            <div style="height: 21px; border-bottom: 1px solid black;">{{ TimeEntry.label }}</div>
                            <div class="" style="display: flex; height: 100%;">
                                <template v-for="entry in TimelineContent" :key="entry.label">
                                    <div v-if="entry.label !== '見込' && entry.label !== '実績' || entry.label === '見込' && TimeEntry.month >= (this.CurrentMikomiDate.getMonth() + 1) || entry.label === '実績' && TimeEntry.month < (this.CurrentMikomiDate.getMonth() + 1)" class="EstimationsDataEntry" :style="`background-color:${entry.color};`">
                                        {{ entry.label }}
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
                <div id="MikomiDataContainer">
                    <MikomiContainer v-if="CurrentMikomi !== null" :TeamFilter="TeamEntries" :Mikomi="CurrentMikomi" :FilteredTimeLine="TimelineEntries" :MikomiCreationDate="CurrentMikomiDate" />
                </div>
            </div>
            
            <div>
                <div>
                    メモ
                </div>
                <div>
                    <textarea id="MemoBox" rows="15" cols="25" v-model="CurrentMikomiMemo" style="background-color: beige;">メモ</textarea>
                </div>
                <div class="Button ButtonNormal" @click="UpdateMikomiMemo">
                    アップデート
                </div>
            </div>
        </div>
        <div id="NewEstimationContainer" v-if="IsNewEstimationVisible === true" style="flex: 1; overflow: auto; padding: 30px 0px;">
            <div style="text-align: center;">
                新しい見込比較を作る為に、先ず、少なくとも、計画ファイルを選択して、アップロードしてください。
            </div>
            <div style="display: grid; width: 100%; justify-content: center; padding: 30px 0px;">
                <div>
                    <span class="LatestUploadLabel">在庫明細の最新アップデート：</span>{{ LatestZaikoUpdate }}
                </div>
                <div>
                    <span class="LatestUploadLabel">計画明細の最新アップデート：</span>{{ LatestKeikakuUpdate }}
                </div>
                <div>
                    <span class="LatestUploadLabel">実績の最新アップデート：</span>{{ LatestJissekiUpdate }}
                    <span>{{ LatestJissekiHint }}</span>
                    <div v-if="IsMissingJissekiData === true" style="place-content: center; display: grid;">
                        <span style="color: red;">先月の実績データはまだありません！</span>
                    </div>
                </div>
                <div style="margin-top: 40px; place-content: center; display: grid;">
                    <div class="NoSelect Button ButtonNormal" @click="RequestMikomi">見込を作成する</div>
                </div>
            </div>
            <div v-if="ShowNewMikomiPreview === true" style="padding: 30px;">
                <p>新しい見込比較を確認してください：</p>
                <div class="Button ButtonNormal NoSelect" @click="RegisterNewMikomi">アップロードする</div>
                <h2>{{ PreviewMikomi.Name }}</h2>

                <template v-for="month in PreviewMikomi.Data" :key="month.Month">
                    <div class="" style="font-weight: bold;">{{ month.Month + '月' }}</div>
                    <div v-for="keikaku in month.Keikaku" :key="keikaku.revision + '_' + keikaku.teamName" style="margin-top: 20px; padding-left: 15px;">
                        {{ keikaku.teamName }} - {{ GetKeikakuPreviewDate(keikaku.added_at) }} [{{ KeikakuRevisionToName(keikaku.revision, new Date(keikaku.added_at)) }}]
                        <div style="padding-left: 15px;">
                            <div><span style="min-width:150px; display: inline-block;">売上：</span>{{ keikaku.sales }}</div>
                            <div><span style="min-width:150px; display: inline-block;">総益仮：</span>{{ keikaku.provProfit }}</div>
                            <div><span style="min-width:150px; display: inline-block;">利益：</span>{{ keikaku.profit }}</div>
                            <div><span style="min-width:150px; display: inline-block;">営業利益：</span>{{ keikaku.operatingProfit }}</div>
                            <div><span style="min-width:150px; display: inline-block;">純利益：</span>{{ keikaku.netIncome }}</div>
                            <div><span style="min-width:150px; display: inline-block;">在庫：</span>{{ keikaku.stock }}</div>
                        </div>
                    </div>
                    <div style="margin-top: 20px; padding-left: 15px;">
                        見込
                        <div style="padding-left: 15px;">
                            <template v-for="estimation in month.Estimation" :key="estimation.month + '_' + estimation.teamName">
                                <div><span style="min-width:150px; display: inline-block;">売上(ﾌｨｷﾞｭｱ)：</span>{{ estimation.sales_figures }}</div>
                                <div><span style="min-width:150px; display: inline-block;">総益仮：</span>{{ estimation.profit_figures }}</div>
                                <div><span style="min-width:150px; display: inline-block;">売上(ﾌﾟﾗﾓ)：</span>{{ estimation.sales_plastic }}</div>
                                <div><span style="min-width:150px; display: inline-block;">総益仮：</span>{{ estimation.profit_plastic }}</div>
                                <div><span style="min-width:150px; display: inline-block;">売上(ﾃﾞｼﾞﾀﾙ)(414)：</span>{{ estimation.sales_digital }}</div>
                                <div><span style="min-width:150px; display: inline-block;">総益仮：</span>{{ estimation.profit_digital }}</div>
                            </template>
                        </div>
                    </div>
                    <div style="min-height: 50px;"></div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import GenericMultiDropdown from '@/components/GenericMultiDropdown.vue';
import GenericDropdown from '@/components/GenericDropdown.vue';
import axios from 'axios';
import MikomiContainer from '@/components/MikomiContainer.vue';

export default {
    components:{
        GenericMultiDropdown,
        GenericDropdown,
        MikomiContainer,
    },
    mounted(){
        this.CurrentMonth = new Date().getMonth() + 1;

        this.SetUpScroll();

        for (let i = 0; i < this.TimelineFilterOptions.length; i++)
        {
            this.$refs.TimelineFilter.ToggleItem(this.TimelineFilterOptions[i].label);
        }

        this.$refs.TeamFilter.ToggleItem(this.TeamFilterOptions[1].label);
        this.$refs.TeamFilter.ToggleItem(this.TeamFilterOptions[0].label);

        this.TimelineEntries = [];
        for (let i = 0; i < this.TimelineOptions.length; i++)
        {
            if (this.TimelineOptions[i].Check(this.TimelineFilterOptions) === true)
            {
                this.TimelineEntries.push({ label: this.TimelineOptions[i].label, month: this.TimelineOptions[i].month });
            }
        }
        console.log("timeline entries", this.TimelineEntries);

        const estContainer = document.getElementById('EstimationBottomContainer');
        if (estContainer !== null)
        {
            const memoBox = document.getElementById('MemoBox');
            if (memoBox !== null)
            {
                // 30px -> bottom padding from EstimationContainer css class
                // 75px -> space for update button
                memoBox.style.maxHeight = `${estContainer.offsetHeight - 30 - 75}px`;
            }
        }

        // this.UpdateTimelineContent();
        this.GetAvailableMikomiInformation();
    },
    methods:{
        async UpdateMikomiMemo()
        {
            const data = {
                SessionToken: this.$GetToken(),
                Memo: this.CurrentMikomiMemo,
                EstimationID: this.CurrentMikomiID,
            };

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}estimation/memo`, data)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error('Could not update memo', error);
            });

            console.log('Update memo result', result);
        },
        SetUpScroll()
        {
            setTimeout(()=>{
                this.DataScrollContainer = document.getElementById('MikomiDataContainer');
                if (this.DataScrollContainer !== null)
                {
                    this.DataScrollContainer.addEventListener('scroll', this.OnDataScroll);
                    this.TimelineScrollContainer = document.getElementById('TimelineScrollContainer');
                    this.LeftSideScrollContainer = document.getElementById('LeftSideScrollContainer');
                }                
            }, 100);
        },
        OnDataScroll(event)
        {
            this.LeftSideScrollContainer.scrollTop = event.target.scrollTop;
            this.TimelineScrollContainer.scrollLeft = event.target.scrollLeft;
        },
        async GetAvailableMikomiInformation()
        {
            if (this.IsPullingMikomiList === false)
            {
                this.IsPullingMikomiList = true;
                const data = {
                    SessionToken: this.$GetToken(),
                };

                const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}estimation/list`, data)
                .then(async response => {
                    return response.data;
                })
                .catch(error => {
                    console.error(error);
                    this.$HandleBadRequest(error.response.status, error.response.data);
                });

                this.IsPullingMikomiList = false;
                this.EstimationList = [];
                console.log('mikomi list', result);

                if (result !== null &&
                    result !== undefined)
                {
                    for (let i = 0; i < result.length; i++)
                    {
                        this.EstimationList.push({label: result[i].name, value: result[i].id });
                    }

                    if (this.EstimationList.length === 0)
                    {
                        this.EstimationList.push({label:'見込比較はまだありません。', value: -1});
                    }

                    this.SelectedMikomiID = this.EstimationList[0].value;
                    this.SelectedMikomiIndex = 0;
                    this.GetMikomi();
                }
            }
        },
        async GetMikomi()
        {
            if (this.SelectedMikomiID === -1)
            {
                return;
            }

            this.IsPullingMikomiID = this.SelectedMikomiID;

            const data = {
                SessionToken: this.$GetToken(),
                ID: this.SelectedMikomiID,
            };

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}estimation`, data)
            .then(async response => {
                return response.data;
            })
            .catch(error => {
                console.error('[EstimationsPage] get mikomi error', error);
            });

            if (result.ID === this.IsPullingMikomiID)
            {
                console.log('[EstimationsPage] Mikomi received', result);

                this.CurrentMikomiDate = new Date(result.Mikomi.created_at);
                this.CurrentMikomi = result.Mikomi.data;
                this.CurrentMikomiID = result.ID;
                this.IsPullingMikomiID = -1;
                this.CurrentMikomiMemo = result.Mikomi.memo;
                this.UpdateTimelineContent();
            }
        },
        GetKeikakuPreviewDate(dateString)
        {
            const date = new Date(dateString);
            return date.toLocaleDateString('ja-JP', { month: '2-digit', year: 'numeric' });
        },
        async RequestMikomi()
        {
            const data = {
                SessionToken: this.$GetToken(),
            };

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}estimation/create`, data, {
                headers:
                {
                    'Content-Type': 'application/json'
                }
            })
            .then(async response =>{
                console.log(`RequestMikomi response`, response.data);
                return response.data;
            })
            .catch(error =>
            {
                console.log(`RequestMikomi received an error`, error);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                return null;
            });
            
            if (result.Mikomi.IsValid === true)
            {
                this.PreviewMikomi = {
                    Data: result.Mikomi.Data,
                    Name: result.Mikomi.Name,
                };
    
                console.log('mikomi result', this.PreviewMikomi);
                this.ShowNewMikomiPreview = true;
            }
            else
            {
                alert("見込を作る為に必要なデータはありませんでした。まずは、必要なデータをアップロードしてください。「計画（+見直計画）、計画明細、在庫明細、実績データ」");
            }
        },
        async RegisterNewMikomi()
        {
            const data = {
                SessionToken: this.$GetToken(),
                Mikomi: this.PreviewMikomi,
            };

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}estimation/register`, data, {
                headers:
                {
                    'Content-Type': 'application/json'
                }
            })
            .then(async response =>{
                console.log(`RequestMikomi response`, response.data);
                if (response.status === 500)
                {
                    return response.data;
                }

                return response.status;
            })
            .catch(error =>
            {
                console.log(`RequestMikomi received an error`, error);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                return null;
            });

            if (isNaN(result) === true)
            {
                // Error handling
            }
            else
            {
                this.GetAvailableMikomiInformation();
                this.ToggleNewEstimation();
            }
        },
        async GetLatestDataDates()
        {
            this.LatestKeikakuUpdate = '確認中';
            this.LatestZaikoUpdate = '確認中';
            this.LatestJissekiUpdate = '確認中';
            this.IsGettingLatestDataDates = true;

            const data = {
                SessionToken: this.$GetToken(),
            };

            let result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}estimation/data/dates`, data, {
                headers:
                {
                    'Content-Type': 'application/json'
                }
            })
            .then(async response => {
                return response.data;
            })
            .catch(error =>
            {
                console.log(`[EstimationsPage](GetLatestDataDates) Error`, error);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }

                return { success: false, error: error.response.status };
            });

            if (result.success !== undefined &&
                result.success === false)
            {
                return;
            }

            this.LatestJissekiData = result.LatestResult;
            const now = new Date();
            this.IsMissingJissekiData = now.getFullYear() > this.LatestJissekiData.year || now.getMonth() + 1 > this.LatestJissekiData.month;

            console.log(`[EstimationsPage](GetLatestDataDates)`, result);
            for (let i = 0; i < result.LastUpload.length; i++)
            {
                if (result.LastUpload[i].uploadType === 'Keikakumeisai')
                {
                    const d = new Date(result.LastUpload[i].latest_upload_date);
                    d.setHours(d.getHours() + 9);
                    this.LatestKeikakuUpdate = d.toLocaleDateString();
                }
                else if (result.LastUpload[i].uploadType === 'Zaikomeisai')
                {
                    const d = new Date(result.LastUpload[i].latest_upload_date);
                    d.setHours(d.getHours() + 9);
                    this.LatestZaikoUpdate = d.toLocaleDateString();
                }
                else if (result.LastUpload[i].uploadType === 'ResultData')
                {
                    const d = new Date(result.LastUpload[i].latest_upload_date);
                    d.setHours(d.getHours() + 9);
                    this.LatestJissekiUpdate = d.toLocaleDateString();
                    this.LatestJissekiHint += ` (${result.LatestResult.year}年${result.LatestResult.month}月まであります)`;
                }
            }
        },
        ToggleNewEstimation()
        {
            const toggleBtn = document.getElementById('EstimationToggleBtn');

            if (this.IsNewEstimationVisible === false)
            {
                if (toggleBtn !== null &&
                    toggleBtn !== undefined)
                {
                    toggleBtn.innerHTML = '戻る';
                }

                this.GetLatestDataDates();
            }
            else
            {
                if (toggleBtn !== null &&
                    toggleBtn !== undefined)
                {
                    toggleBtn.innerHTML = '新しい';
                }

                this.ShowNewMikomiPreview = false;
                this.PreviewMikomi = null;
                this.SetUpScroll();
            }
            
            this.IsNewEstimationVisible = !this.IsNewEstimationVisible;
        },
        OpenResultDetails()
        {
            this.$router.push('/estimations/details');
        },
        OnSelectEstimation(event)
        {
            console.log('[EstimationsPage](OnSelectEstimation) Event', event);
            this.SelectedMikomiID = event.target.options[event.target.options.selectedIndex].value;
            this.SelectedMikomiIndex = event.target.options.selectedIndex;
            this.GetMikomi();
        },
        UpdateTimelineContent()
        {
            this.TimelineContent = [];

            console.log('Current mikomi', this.CurrentMikomi);
            let timelineSet = new Set();
            for (let i = 0; i < this.CurrentMikomi.length; i++)
            {
                const month = this.CurrentMikomi[i];
                for (let j = 0; j < month.Keikaku.length; j++)
                {
                    // if undefined, it's mikomi so we don't have to continue
                    if (month.Keikaku[j].revision === undefined)
                    {
                        break;   
                    }
                    
                    const name = this.KeikakuRevisionToName(month.Keikaku[j].revision, new Date(month.Keikaku[j].added_at));
                    if (timelineSet.has(name) === false)
                    {
                        timelineSet.add(name);
                        this.TimelineContent.push({ label: name, color: this.KeikakuRevisionToColor(month.Keikaku[j].revision)});
                    }
                }
            }

            // ToDo: Continue here
            //       Have to find out how to add
            //       実績 and 差額
            // For making the design, we add both for now
            for (let i = 0; i < this.FixedOptions.length; i++)
            {
                this.TimelineContent.push(this.FixedOptions[i]);
            }

            // console.log('Updated timeline content', this.TimelineContent);
            // console.log('current month', this.CurrentMonth);
        },
        OnTeamFilterChange(filter)
        {
            this.TeamEntries = [];

            for (let i = 0; i < filter.length; i++)
            {
                this.TeamEntries.push(filter[i].label);
            }
        },
        OnTimelineFilterChange(filter)
        {
            this.TimelineEntries = [];

            for (let i = 0; i < this.TimelineOptions.length; i++)
            {
                if (this.TimelineOptions[i].Check(filter) === true)
                {
                    this.TimelineEntries.push({ label: this.TimelineOptions[i].label, month: this.TimelineOptions[i].month });
                }
            }
        },
        KeikakuRevisionToName(revision, date)
        {
            switch (revision)
            {
                case 0: return `${date.getMonth() + 1}/${date.getDate()} 計画`;
                case 1:
                case 2:
                case 3:
                    return `${date.getMonth() + 1}月見直計画`;

                default: 'NA_計画';
            }
        },
        KeikakuRevisionToColor(revision)
        {
            switch(revision)
            {
                case 0: return '#D8E4BC';
                case 1: return '#FDE9D9';
                case 2: return '#E4DFEC';
                case 3: return '#FFFF99';

                default: '#FF9900';
            }
        },
        IsTeamFiltered(team)
        {
            return this.TeamEntries.includes(team);
        },
    },
    data(){
        return{
            CurrentMonth: 1,
            IsGettingLatestDataDates: false,
            LatestZaikoUpdate: '',
            LatestKeikakuUpdate: '',
            LatestJissekiUpdate: '',
            LatestJissekiHint: '',
            LatestJissekiData: null,
            IsMissingJissekiData: false,
            IsNewEstimationVisible: false,
            TimelineFilterOptions: [
                { label: '月', value: 0 },
                { label: 'Q', value: 1 },
                { label: '上期/下期', value: 2 },
            ],
            TeamFilterOptions: [
                { label: 'フィギュア', value: 0 },
                { label: 'プラモ', value: 1 },
                { label: 'デジタル', value: 2 },
                { label: 'XPNA', value: 3 },
            ],
            TeamEntries: [],
            EstimationDataTypes: [
                { label: '売上'},
                { label: '総益(仮)'},
                { label: '総益率'},
                { label: '総益'},
                { label: '営業利益'},
                { label: '営業利益率'},
                { label: '純利益'},
                { label: '在庫'},
            ],
            TimelineOptions: [
                { label: '1月', month: 1, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '2月', month: 2, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '3月', month: 3, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: 'Q1', month: 3, Check: (filter)=>{
                    return filter.some(item => item.label === 'Q');
                }},
                { label: '4月', month: 4, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '5月', month: 5, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '6月', month: 6, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: 'Q2', month: 6, Check: (filter)=>{
                    return filter.some(item => item.label === 'Q');
                }},
                { label: '上期', month: 6, Check: (filter)=>{
                    return filter.some(item => item.label === '上期/下期');
                }},
                { label: '7月', month: 7, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '8月', month: 8, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '9月', month: 9, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: 'Q3', month: 9, Check: (filter)=>{
                    return filter.some(item => item.label === 'Q');
                }},
                { label: '10月', month: 10, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '11月', month: 11, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: '12月', month: 12, Check: (filter)=>{
                    return filter.some(item => item.label === '月');
                }},
                { label: 'Q4', month: 12, Check: (filter)=>{
                    return filter.some(item => item.label === 'Q');
                }},
                { label: '下期', month: 12, Check: (filter)=>{
                    return filter.some(item => item.label === '上期/下期');
                }},
                // eslint-disable-next-line
                { label: 'TTL', month: 12, Check: (filter)=>{
                    return true;
                }},
            ],
            TimelineEntries: [],
            FixedOptions: [
                { label: '見込', color: '#DAEEF3'},
                { label: '実績', color: '#DAEEF3'},
                { label: '差額', color: '#FFFFFF'},
            ],
            TimelineContent: [],
            SelectedMikomiIndex: 0,
            EstimationList: [],
            ShowNewMikomiPreview: false,
            PreviewMikomi: null,
            SelectedMikomiID: -1,
            IsPullingMikomiList: false,
            IsPullingMikomiID: -1,
            CurrentMikomiDate: null,
            CurrentMikomi: null,
            CurrentMikomiID: -1,
            CurrentMikomiMemo: '',
        }
    },
}
</script>

<style>
.TriangleBtnVisible
{
    visibility: visible;
}

#EstimationsWrapper
{
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    overflow: hidden;
}

#EstimationTopContainer
{
    display: flex;
    height: 100px;
}

#EstimationSelectionContainer
{
    display: flex;
    flex: 1;
    align-content: center;
    justify-content: center;

    div {
        align-content: center;
    }

    div + div {
        margin-left: 10px;
    }
}

#EstimationDataFilterContainer
{
    width: 500px;
}

#EstimationBottomContainer
{
    display: flex;
    flex: 1;
    overflow: hidden;
    padding-right: 40px;
}

#EstimationsTeamsContainer
{
    min-width: 270px;
    max-width: 270px;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;

    .EstimationsTeamEntry
    {
        display: flex;
    }

    .EstimationsTeamEntry + .EstimationsTeamEntry
    {
        margin-top: 8px;
    }

    .EstimationTeamName
    {
        padding-left: 15px;
        align-content: center;
        width: 130px;
    }

    .EstimationTeamData
    {
        width: 220px;
        div {
            border: 1px solid black;
            min-height: 24px;
        }
    }
}

.EstimationsDataHeader
{
    height: 48px;
    width: fit-content;
    box-sizing: border-box;
    overflow-x: auto;
    scrollbar-width: none;

    .EstimationsDataTimelineEntry:last-of-type {
        border-right: 1px solid black;
    }
}

#EstimationsDataContainer
{
    flex: 1;
    width: 1px;
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
}

.EstimationsDataHeaderPadding
{
    /* padding-right: 50px; */
}

.EstimationsDataTimelineEntry
{
    white-space: nowrap;
    text-align: center;
    
    border-left: 1px solid black;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
}

.EstimationsDataEntry
{
    white-space: nowrap;
    width: 100px;
    padding: 0px 5px;
    text-align: center;
}

.EstimationKeikakuImport
{
    border: 1px solid gray;
    border-radius: 10px;
    padding: 10px 20px;
    /* height: 20px; */
    cursor: pointer;
    text-align: center;

    div {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    div + div {
        margin-top: 8px;
    }

    div:last-of-type {
        label {
            margin-right: 8px;
        }
    }

    label {
        cursor: pointer;
        margin-left: 5px;
    }

    img {
        filter: invert(100%);
    }

    input[type=file] {
        display: none;
    }

    input[type=number]{
        width: 70px;
        text-align: center;
    }
}

.EstimationKeikakuImport:hover
{
    background-color: #eee;
}

.EstimationKeikakuImport + .EstimationKeikakuImport
{
    margin-left: 20px;
}

.SelectedKeikakuFile
{
    background-color: green;
}

#MikomiDataContainer
{
    overflow: auto;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    .MikomiDataCell
    {
        border: 1px solid black;
        padding: 0px 5px;
        width: 100px;
        min-height: 24px;
        align-content: center;
    }

    .EstimationsTeamEntry + .EstimationsTeamEntry
    {
        margin-top: 8px;
    }

    .EstimationsDataEntry:first-of-type
    {
        /* margin-left: 1px; */
    }

    .EstimationsDataEntry
    {
        min-width: 110px;
        padding: 0px;
    }
}

#LeftSideScrollContainer
{
    scrollbar-width: none;
    padding-bottom: 30px;
    overflow-y: auto;
}

#TimelineScrollContainer
{
    display: flex;
    width: 100%;
    min-height: 48px;
    max-height: 48px;
}

.LatestUploadLabel
{
    width: 230px;
    display: inline-block;
    text-align: right;
}
</style>